import React, { useCallback, useEffect, useState } from "react";
import './student-registration.css'
import { EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import { IconContext } from 'react-icons';
import csLogo from '../../assets/images/cybersquare_logo.png'
// import googleIcon from '../../assets/images/google_icon.png'
import infoIcon from '../../assets/images/info-icon.svg'
import { useNavigate, useParams } from "react-router-dom";
import PhoneInput from 'react-phone-input-2'
import { requestForStudentRegistration, getInviteLinkDetails, validateExternalUsername } from "../../services/login-api.js";
import ProfileSetupModal from "../modal/profileSetup-modal.js";
import StudentRegistrationStatus from "./student-registration-status.js";
import { useForm } from "react-hook-form";
import { global_var } from "../../services/login-config.js";

const StudentRegistration = () => {

    const [mobileNumber, setMobileNumber] = useState({ dialCode: '+91', number: '' });
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [IsStatusVisible, setIsStatusVisible] = useState(false);
    const [modalMessage, setModalMessage] = useState('');
    const [signupStatus, setStatus] = useState(200)
    const [maxDate, setMaxDate] = useState('');
    const [linkDetail, setLinkDetail] = useState({})
    const [userNameInfo, setUserNameInfo] = useState(false)
    const [mobileInfo, setMobileInfo] = useState(false)
    const [MobileUserNameInfo, setMobileUserNameInfo] = useState('')
    const [MobilesSreenMobileInfo, setMobileScreenMobileInfo] = useState('')
    const [registredData, setregistredData] = useState()
    const [userNameExists, setUserNameExists] = useState(false)

    const navigate = useNavigate();
    let { ecryptedData } = useParams();

    const form = useForm({});
    const { register, setError, clearErrors, handleSubmit, formState, watch, trigger} = form
    const { errors } = formState;

    const pswd = watch('password', '');
    const confirmPwd = watch('confirmPswd', '');
    const selectedGender = watch('gender', '');
    const selectedDob = watch('dob', '')

    const getUserProfile = useCallback(async (ecryptedData) => {

        try {

            const response = await getInviteLinkDetails({ 'encryptedCode': ecryptedData });
            // Handle the response here
            if (response.data.statusCode === 200) {

                if (response.data.details && response.data.details.inviteLinkState === "activated") {
                    setLinkDetail(response.data.details)
                }else{
                    setStatus(400)
                    setIsStatusVisible(true)
                }

            }else if(response.data.statusCode === 404){
                setIsStatusVisible(true);
                setStatus(404);
            }else {
                setIsStatusVisible(true);
                setStatus(404);
            }

        } catch (error) {

            if (error.response) {
                setModalMessage("Your account has already created. Please try to log in.");
                setIsModalVisible(true);
            }

        }

    }, [])

    useEffect(() => {

        if (ecryptedData) {

            getUserProfile(ecryptedData)
            // for getting current date
            // alredy used in Date Of Birth Input. For Preventing Future Date
            const today = new Date();
            const year = today.getFullYear();
            const month = String(today.getMonth() + 1).padStart(2, '0');
            const day = String(today.getDate()).padStart(2, '0');
            const formattedDate = `${year}-${month}-${day}`;
            setMaxDate(formattedDate);

        } else {
            navigate('/login')
        }

    }, [ecryptedData, getUserProfile, navigate]);

    const togglePasswordVisibility = () => {
        setShowPassword((prevShowPassword) => !prevShowPassword);
    };

    const toggleConfirmPasswordVisibility = () => {
        setShowConfirmPassword((prevShowPassword) => !prevShowPassword)
    }

    const handleModalClose = () => {
        setIsModalVisible(false);
    };

    const handleCutomStatusResponse = (e) => {
        setIsStatusVisible(e.IsStatusVisible)
    }


    const onSubmit = async (data) => {

        try {

            const valid = await trigger(['name', 'userName', 'password', 'confirmPswd'])
            if(valid && global_var.companyId){

                if(userNameExists){
                    setError('userName', {
                        type: 'manual',
                        message: 'Username has already been taken',
                    });
                    return
                }

                const payload = {
                    encryptedCode: ecryptedData,
                    classId: linkDetail.fkClassId,
                    divisionId: linkDetail._id,
                    firstName: data.name,
                    userName: data.userName,
                    password: data.password,
                    classDivisionDetails: {
                        classId: linkDetail.fkClassId,
                        divisionId: linkDetail._id,
                        academicYearId: linkDetail.academicYear
                    }
                }
                if(linkDetail.academicYear){
                    payload['academicYearId'] = linkDetail.academicYear
                }

                if(global_var.parentCompanyId){
                    payload['childCompanyId'] = global_var.companyId
                    payload['companyId'] = global_var.parentCompanyId
                }else{
                    payload['companyId'] = global_var.companyId
                }
                if(data.parentemail){
                    if(validEmail(data.parentemail)){
                        payload['guardianEmail'] = data.parentemail
                    }else{
                        return
                    }
                }

                if(mobileNumber.number){
                    payload['mobile'] = mobileNumber.number
                }

                if(mobileNumber.dialCode){
                    payload['dialCode'] = mobileNumber.dialCode
                }

                if(data.gender){
                    payload['gender'] = data.gender
                }

                if(data.dob){
                    payload['dob'] = data.dob
                }

                // Make the asynchronous call
                const response = await requestForStudentRegistration(payload);
                // Handle the response here
                if (response.data && response.data.statusCode === 200) {
                    const userInfo = {
                        'firstName': data.name,
                        'userName': data.userName,
                        'password': data.password,
                        'companyUrl': global_var.domain_name
                    }
                    setregistredData(userInfo)
                    setIsStatusVisible(true);
                    setStatus(200)
                }else if(response.message){
                    setIsModalVisible(true)
                    setModalMessage(response.message);
                }else {
                    setStatus(401)
                    setIsStatusVisible(true)
                }

            }

        } catch (error) {
            setModalMessage("An error occurred. Please contact the administrator for assistance.");
        }
    };

    const validEmail = async (email) => {
        const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
        return regex.test(email)
    }

    const handleMobileInput = (value, data) => {
        const obj = {
            dialCode: data['dialCode']
        }
        const number = value.startsWith(data['dialCode']) ? value.slice(data['dialCode'].length) : value;
        obj['number'] = number
        setMobileNumber(obj)
    }

    let cacheTimeOut;
    const validateUserName = async (userName) => {

        if(!userName){
            return
        }
        var payload = {
            'code': ecryptedData,
            'userName' : userName
        }

        if(global_var.parentCompanyId){
            payload['childCompanyId'] = global_var.companyId
            payload['companyId'] = global_var.parentCompanyId
        }else{
            payload['companyId'] = global_var.companyId
        }
        if (cacheTimeOut) {
            clearTimeout(cacheTimeOut);
        }
        cacheTimeOut = setTimeout(async () => {
            const response = await validateExternalUsername(payload)
            if(response.data.exists){
                setError('userName', {
                    type: 'manual',
                    message: 'Username has already been taken',
                });
                setUserNameExists(true)
            }else{
                clearErrors('userName');
                setUserNameExists(false)
            }
        }, 700)

    }


    return (
        <>
            <div className='container-fluid'>
                <div className='row main-background-profileSetup'>
                    <div className='col-12 d-flex justify-content-center align-items-center' style={{ padding: '20px 0px', backgroundColor:'#FEF8F8' }}>
                        {!IsStatusVisible ? (

                            <div className='col-xl-5 col-lg-7 col-md-8 col-sm-8 col-12 p-4 rounded-4 form'>
                                <div className="col-11 mt-0 mb-4" style={{ display: 'flex', justifyContent: 'center' }}>
                                    <img src={csLogo} className="csLogo" alt="cs logo" style={{ width: '180px' }} />
                                </div>
                                <div className="col-12 mt-1 mb-3" style={{ display: 'flex', justifyContent: 'center' }}>
                                    <h3 className="col-12" style={{ fontFamily: 'Poppins', fontSize: '17px', textAlign: 'center'}}>You are here to register a student in <span style={{fontWeight: 800, fontFamily: 'sans-serif'}}>class {linkDetail.classAlias} division {linkDetail.divisionName} Of {global_var.company_name}</span></h3>
                                </div>

                                {/* registration Form */}

                                <form data-testid='profileForm' className="row" style={{display: 'flex', justifyContent: 'center'}} onSubmit={handleSubmit(onSubmit)}>

                                    {/* <div className="col-1"></div> */}
                                    <div className="form-group mb-md-3 mb-3 col-11 col-sm-10" >
                                        <label htmlFor="username" className='pb-3 pb-md-2 custom-label d-none d-sm-block' >Student Name*</label>
                                        <input
                                            type="text"
                                            id="studentname"
                                            className='new-form-control rounded-1 border-0 input-height'
                                            placeholder="Enter Student Name"
                                            name="studentName"
                                            {...register('name', {
                                                required: {
                                                    value: true,
                                                    message: 'This field cannot be empty. Please enter student name'
                                                }
                                            })}
                                        />
                                        <div className="error-message">{errors.name?.message}</div>
                                    </div>

                                    {/* <div className="col-1"></div> */}
                                    <div className="form-group mb-md-3 mb-3 col-10 col-sm-10">
                                        <label htmlFor="username" className='pb-3 pb-md-2 custom-label d-none d-sm-inline-block' >Username*</label>
                                        <img className="infoIcon d-none d-sm-inline-block" src={infoIcon} alt="info-icon" onClick={() => setUserNameInfo(!userNameInfo)}/>
                                        {userNameInfo ? (
                                            <label htmlFor="username" className='pb-3 pb-md-2 info-label d-none d-sm-inline'>Username can be any unique name of your choice, Student ID, admission number or email Id</label>
                                        ): (null)}
                                        <input
                                            type="text"
                                            id="userName"
                                            className='new-form-control rounded-1 border-0 input-height user-name-input'
                                            placeholder="Any unique Student ID, Admission No. or Email"
                                            name="userName"
                                            {...register('userName', {
                                                required: {
                                                    value: true,
                                                    message: 'This field cannot be empty. Please enter username'
                                                },
                                            })}
                                            onChange={(e) => validateUserName(e.target.value)}
                                        />
                                        <div className="error-message">{errors.userName?.message}</div>
                                        <span className={`tooltip-text ${MobileUserNameInfo ? 'active': ''}`}>Username can be any unique name of your choice, Student ID, admission number or email Id</span>
                                    </div>
                                    <div className="col-1 d-sm-none">
                                        <img className="mobile-infoIcon d-block d-sm-none" alt="mobile-info-icon" src={infoIcon} onClick={() => setMobileUserNameInfo(!MobileUserNameInfo)} />
                                    </div>
                                    {/* <div className="col-1"></div> */}
                                    {/* <div className="col-1"></div> */}
                                    <div className="form-group mb-md-3 mb-3 col-11 col-sm-10">
                                        <label htmlFor="username" className='pb-3 pb-md-2 custom-label d-none d-sm-block' >Parent Email</label>
                                        <input
                                            type="text"
                                            id="parentemail"
                                            className='new-form-control rounded-1 border-0 input-height'
                                            placeholder="Parent Email"
                                            name="Parent Email"
                                            {...register('parentemail', {
                                                required: {
                                                    value: false
                                                },
                                                pattern: {
                                                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                                    message: 'Invalid email address'
                                                }
                                            })}
                                        />
                                        <div className="error-message">{errors.parentemail?.message}</div>
                                        
                                    </div>

                                    {/* <div className="col-1"></div> */}
                                    
                                    {/* <div className="col-1"></div> */}
                                    <div className="form-group mb-md-3 mb-3 col-10 col-sm-10">
                                        <label htmlFor="username" className='pb-3 pb-md-2 custom-label d-none d-sm-inline-block'>Phone Number</label>
                                        <img className="infoIcon d-none d-sm-inline-block" alt="info-icon" src={infoIcon} onClick={() => setMobileInfo(!mobileInfo)}/>
                                        {mobileInfo ? (
                                            <label htmlFor="username" className='pb-3 pb-md-2 info-label d-none d-sm-inline'>Enter your mobile number for OTP sign-in</label>
                                        ): (null)}
                                        <PhoneInput
                                            placeholder={'Enter Number'}
                                            value={
                                                `+${mobileNumber.dialCode}${mobileNumber.number}`
                                            }
                                            containerClass={"form-group mb-md-3 mb-2 rounded-1 border-0 input-height "}
                                            inputStyle={{ width: '100%', height: '40px', boxShadow: '0 0 0 .05rem #f5692d', paddingLeft: '70px', border: 'none' }}
                                            inputProps={{
                                                name: 'mobile',
                                                autoFocus: false,
                                            }}
                                            onChange={(value, data) => handleMobileInput(value, data)}
                                        />
                                        <span className={`mobile-tooltip-text ${MobilesSreenMobileInfo ? 'active': ''}`}>Enter your mobile number for OTP sign-in</span>
                                    </div>
                                    <div className="col-1 d-sm-none">
                                        <img className="mobile-infoIcon d-block d-sm-none" alt="mobile-info-icon" src={infoIcon} onClick={() => setMobileScreenMobileInfo(!MobilesSreenMobileInfo)} />
                                    </div>

                                    {/* <div className="col-1"></div>
                                    <div className="col-1"></div> */}
                                    <div className="form-group mb-md-3 mb-3 col-6 col-sm-5" >
                                        <label htmlFor="gender" className='pb-3 pb-md-2 custom-label d-none d-sm-block' >Gender</label>
                                        <select
                                            name="gender"
                                            id="gender"
                                            className={`new-form-control rounded-1 border-0 input-height`}
                                            style={{ color: selectedGender === '' ? 'rgb(157, 157, 157)' : 'black', fontSize: selectedGender === ''? '16px': '14px' }}
                                            {...register('gender')}
                                        >
                                            <option disabled selected value='' >Select Gender</option>
                                            <option value='male'>Male</option>
                                            <option value='female'>Female</option>
                                            <option value='Other'>Other</option>
                                            <option value='Prefer not to say'>Prefer not to say</option>
                                        </select>
                                    </div>

                                    <div className="form-group mb-md-3 mb-3 col-5" >
                                        <label htmlFor="gender" className='pb-3 pb-md-2 custom-label d-none d-sm-block' >DOB</label>
                                        <input
                                            type="date"
                                            id="dob"
                                            name="dob"
                                            className='new-form-control rounded-1 border-0 input-height'
                                            placeholder="dob"
                                            max={maxDate}
                                            {...register('dob')}
                                            style={{ color: selectedDob === '' ? 'rgb(157, 157, 157)' : 'black', fontSize: selectedDob === '' ? '16px': '14px' }}
                                        />
                                    </div>

                                    {/* <div className="col-1"></div>

                                    <div className="col-1"></div> */}
                                    <div className="form-group mb-md-3 mb-3 col-11 col-sm-10">
                                        <div className='input-group'>
                                            <label htmlFor="gender" className='pb-3 pb-md-2 custom-label d-none d-sm-block' >Password</label>
                                            <input
                                                type={showPassword ? 'text' : 'password'}
                                                id='pswd'
                                                className='new-form-control rounded-1 border-0 input-height'
                                                placeholder="Enter password"
                                                name="password"
                                                {...register('password', {
                                                    required: {
                                                        value: true,
                                                        message: 'Password must be minimum 5 Characters.'
                                                    },
                                                    minLength: {
                                                        value: 5,
                                                        message: 'Password must be minimum 5 Characters'
                                                    },
                                                })}
                                            />

                                            {pswd.length > 0 && (
                                                <div className='input-group-append'>
                                                    <IconContext.Provider value={{ size: '1.5em' }}>
                                                        <span className='input-group-text' onClick={togglePasswordVisibility} style={{ border: 'none', cursor: 'pointer', backgroundColor: 'transparent', marginLeft: '-37px', position: 'absolute', marginTop: '11px' }}>
                                                            {showPassword ? <EyeOutlined /> : <EyeInvisibleOutlined />}
                                                        </span>
                                                    </IconContext.Provider>
                                                </div>
                                            )}
                                            <div className="error-message">{errors.password?.message}</div>
                                        </div>
                                    </div>
                                    {/* <div className="col-1"></div>

                                    <div className="col-1"></div> */}
                                    <div className="form-group md-mb-4 mb-3 col-11 col-sm-10">
                                        <div className='input-group'>
                                        <label htmlFor="gender" className='pb-3 pb-md-2 custom-label d-none d-sm-block' >Confirm Password</label>
                                            <input
                                                type={showConfirmPassword ? 'text' : 'password'}
                                                id='confirmPswd'
                                                className={`new-form-control rounded-1 border-0 input-height`}
                                                placeholder='Confirm password'
                                                name="confirmPswd"
                                                {...register('confirmPswd', {
                                                    required: {
                                                        value: true,
                                                        message: 'Password must match the above password.'
                                                    },
                                                    validate: value => value === pswd || 'Password must match the above password'
                                                })}
                                            />

                                            {confirmPwd.length > 0 && (
                                                <div className='input-group-append'>
                                                    <IconContext.Provider value={{ size: '1.5em' }}>
                                                        <span className='input-group-text' onClick={toggleConfirmPasswordVisibility} style={{ border: 'none', cursor: 'pointer', backgroundColor: 'transparent', marginLeft: '-37px', position: 'absolute', marginTop: '11px' }}>
                                                            {showConfirmPassword ? <EyeOutlined /> : <EyeInvisibleOutlined />}
                                                        </span>
                                                    </IconContext.Provider>
                                                </div>
                                            )}
                                            <div className="error-message">{errors.confirmPswd?.message}</div>
                                        </div>
                                    </div>
                                    {/* <div className="col-1"></div> */}


                                    <div className="text-center mt-1 mt-md-4 col-12">
                                        <div style={{ display: 'flex', justifyContent: 'center' }} className="mb-md-1">
                                            <div className="col-11 col-sm-10">
                                                <button type="submit" className="btn btn-warning form-control" style={{
                                                    backgroundColor: "#FF0000",
                                                    color: "white",
                                                    borderRadius: "10px",
                                                    display: "block",
                                                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.1)",
                                                    height: '50px'
                                                }} data-testid='signInButton' >Sign Up</button>
                                            </div>
                                        </div>
                                    </div>

                                    {/* <div className="col-12 mt-3 mb-2">
                                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                                            <div className="lined-text-container col-11 col-sm-10">
                                                <span className="lined-text">Or</span>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12">
                                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                                            <div className="col-11 col-sm-10">
                                                <button type="button" className='google-button mt-2' >
                                                    <img src={googleIcon} alt="google icon" className='icon img-google' />
                                                    <span className='responsive-google-text' style={{ fontFamily: 'Poppins', fontWeight: 'bold' }}>Sign in with Google</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div> */}

                                </form>
                            </div>
                        ) : (
                            <StudentRegistrationStatus
                                status={signupStatus}
                                data={registredData ? registredData : ''}
                                response={handleCutomStatusResponse}
                            />
                        )
                        }
                    </div>
                </div>
                {/* Modal section */}
                <ProfileSetupModal
                    visible={isModalVisible}
                    onClose={handleModalClose}
                    message={modalMessage} // Pass the message to the modal
                />
            </div>
        </>

    );

};

export default StudentRegistration;